import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Label from "../../../../ExecutiveList/Spreadsheet/parts/Label";
import { convertDepartmentKeysToTags } from '../../../../../utils/utils';

const styles = () => ({
  tagsRoot: {
    marginTop: "10px",
    marginLeft: "-4px",
    padding: "0px 20px",
  },
  departmentCategoryTitle: {
    color: "#181819",
    fontSize: "13px",
    boxSizing: "border-box",
    fontWeight: "bold",
    borderBottom: "1px solid #D8DBDF",
    paddingBottom: "10px",
    marginBottom: "10px",
  },
  tagsContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    overflow: "hidden",
    maxHeight: "45px",
  },
  tag: {
    marginRight: "2px",
    padding: "4px",
  },
  ellipsis: {
    marginLeft: "4px",
    color: "#71737B",
    fontSize: "12px",
  },
});

class DepartmentTags extends React.Component {
  render () {
    const { classes, departmentKeys } = this.props;

    const tags = convertDepartmentKeysToTags(departmentKeys);

    return (
      <div>
        {tags.length > 0 && (
          <div className={classes.tagsRoot}>
            <div className={classes.departmentCategoryTitle}>部門カテゴリー</div>
            <div className={classes.tagsContainer}>
              {tags.map((tag, index) => (
                <div key={index} className={classes.tag}>
                  <Label
                    labelText={tag}
                    labelColor="#FFFFFF"
                    labelBgColor="#FD7E00"
                    fontWeight="normal"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

DepartmentTags.propTypes = {
  classes: PropTypes.object.isRequired,
  departmentKeys: PropTypes.array,
}

PropTypes.defaultValue = {
}

export default withStyles(styles)(DepartmentTags);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/parts/DepartmentTags.jsx